import { render } from "./AbtestForm.vue?vue&type=template&id=6d71bf27"
import script from "./AbtestForm.vue?vue&type=script&lang=js"
export * from "./AbtestForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__